import { useCallback, useEffect, useState } from "react";
import Select from "react-select";
import { useLiveAPIContext } from "../../contexts/LiveAPIContext";

const voiceOptions = [
  // English voices (HD)
  { value: "Puck", label: "Puck (English HD)" },
  { value: "Charon", label: "Charon (English HD)" },
  { value: "Kore", label: "Kore (English HD)" },
  { value: "Fenrir", label: "Fenrir (English HD)" },
  { value: "Aoede", label: "Aoede (English HD)" },
  // Vietnamese voices - Female
  { value: "vi-VN-Wavenet-A", label: "vi-VN-Wavenet-A (Nữ)" },
  { value: "vi-VN-Wavenet-C", label: "vi-VN-Wavenet-C (Nữ)" },
  { value: "vi-VN-Standard-A", label: "vi-VN-Standard-A (Nữ)" },
  { value: "vi-VN-Standard-C", label: "vi-VN-Standard-C (Nữ)" },
  { value: "vi-VN-Neural2-A", label: "vi-VN-Neural2-A (Nữ)" },
  // Vietnamese voices - Male
  { value: "vi-VN-Wavenet-B", label: "vi-VN-Wavenet-B (Nam)" },
  { value: "vi-VN-Wavenet-D", label: "vi-VN-Wavenet-D (Nam)" },
  { value: "vi-VN-Standard-B", label: "vi-VN-Standard-B (Nam)" },
  { value: "vi-VN-Standard-D", label: "vi-VN-Standard-D (Nam)" },
  { value: "vi-VN-Neural2-D", label: "vi-VN-Neural2-D (Nam)" },
];

export default function VoiceSelector() {
  const { config, setConfig } = useLiveAPIContext();

  useEffect(() => {
    const voiceName =
      config.speechConfig?.voiceConfig?.prebuiltVoiceConfig?.voiceName ||
      "Atari02";
    const voiceOption = { value: voiceName, label: voiceName };
    setSelectedOption(voiceOption);
  }, [config]);

  const [selectedOption, setSelectedOption] = useState<{
    value: string;
    label: string;
  } | null>(voiceOptions[0]);

  const updateConfig = useCallback(
    (voiceName: string) => {
      setConfig({
        ...config,
        speechConfig: {
          voiceConfig: {
            prebuiltVoiceConfig: {
              voiceName: voiceName,
            },
          },
        },
      });
    },
    [config, setConfig]
  );

  return (
    <div className="select-group">
      <label htmlFor="voice-selector">Voice</label>
      <Select
        id="voice-selector"
        className="react-select"
        classNamePrefix="react-select"
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            background: "var(--Neutral-15)",
            color: "var(--Neutral-90)",
            minHeight: "33px",
            maxHeight: "33px",
            border: 0,
          }),
          option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            backgroundColor: isFocused
              ? "var(--Neutral-30)"
              : isSelected
              ? "var(--Neutral-20)"
              : undefined,
          }),
        }}
        value={selectedOption}
        defaultValue={selectedOption}
        options={voiceOptions}
        onChange={(e) => {
          setSelectedOption(e);
          if (e) {
            updateConfig(e.value);
          }
        }}
      />
    </div>
  );
}
